export const emailValidator = (email?: string): boolean => {
  if (!email) return false;

  const re = /^[^\s@]+@[^\s@]+$/;

  if (!re.test(email)) return false;

  return true;
};
